import { jsxs as l, jsx as r } from "react/jsx-runtime";
const c = ({
  width: t,
  height: e,
  className: i
}) => /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    fill: "none",
    height: e,
    viewBox: "0 0 14 14",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r(
        "circle",
        {
          cx: "7",
          cy: "7",
          fill: "currentColor",
          r: "7"
        }
      ),
      /* @__PURE__ */ r(
        "rect",
        {
          fill: "white",
          height: "1",
          rx: "0.5",
          width: "5.5",
          x: "4.3999",
          y: "6.60352"
        }
      )
    ]
  }
);
export {
  c as Content
};
